import { Talent } from '../../Classes'

const tier7 = [
  null,
  new Talent(
    'Ice Barrier',
    'spell_ice_lament',
    ['Instantly shields you, absorbing 455 damage. Lasts 1 min. While the shield holds, spells will be interrupted.'],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    '305 mana',
    null,
    'Instant',
    '30 sec cooldown'
  ),
  null,
  null,
]

export default tier7
